import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { SignupSurveyService } from './signup-survey.service';
import { NavigationEnd, Router } from '@angular/router';
import { AnalyticsService } from '@laasy/common-layout';
import { RouteRenderModalService } from 'src/app/shared/services/route-render-modal.service';
import { ProfileService } from 'src/app/shared/services/profile.service';
import { AuthenticationService } from 'src/app/shared/services/authentication/authentication.service';
import { MissingInfoModalService } from 'src/app/shared/services/missing-info-modal.service';

@Injectable({
  providedIn: 'root'
})
export class ProfileCompletionService {
  callProfileCompletion = false;
  email: string = '';
  isUserProfileCompleted = false;
  isLogin = false;
  userEmail: string = '';
  FieldsToCheck =  ['First name', 'Last name','Email', 'Phone number', 'Zip Code', 'Gender', 'Age Range', 'Country']
  constructor(private authenticationService: AuthenticationService, private surveyService: SignupSurveyService, private router: Router, private analyticsService: AnalyticsService, private routeRenderModalService: RouteRenderModalService, private profileService: ProfileService, private missingInfoModalService: MissingInfoModalService) {
    this.router.events.subscribe((event) => {
      if(event instanceof NavigationEnd){
        this.openProfileCompletion();
      }
    });
  }

  async checkUserProfileAttributes(): Promise<boolean> {
    const res: any = await firstValueFrom(this.profileService.GetUserProfile());
    const isCompleted = this.FieldsToCheck.every((x: any) => res.data.attributes.find((y: any) => y.title === x)?.value !== '');
    this.userEmail = res.data.attributes.find((x: any) => x.title === 'Email')?.value || 'Unknown';
    return isCompleted;
  }

  private openProfileCompletion() {
    if (this.callProfileCompletion && !window.location.href.includes('(modal:')){
      this.callProfileCompletion = false;
      const isFirstLogin = Boolean(localStorage.getItem('onboardingFlag'))
      if(isFirstLogin) return;
      this.missingInfoModalService.openProfileCompletion(this.email)
    }

  }

  async authGuardCheckProfileCompletion(): Promise<boolean> {
    const result = await this.checkProfileCompletion();
    return result;
  }

  async loginCheckProfileCompletion(email: string): Promise<boolean> {
    this.missingInfoModalService.forcedProfileCompletion = true;
    this.callProfileCompletion = true;
    this.isLogin = true;
    this.email = email;
    const isCompleted = await this.isUserProfileComplete();
    return isCompleted;
  }


  async checkProfileCompletion(): Promise<boolean> {
    if (this.isUserProfileCompleted) return true;
    const isFirstLogin = Boolean(localStorage.getItem('onboardingFlag'))
    const isCompleted = isFirstLogin ? true : await this.isUserProfileComplete();
    this.isUserProfileCompleted = isCompleted;
    return isCompleted;
  }

  get isSkipable(): boolean {
    return this.missingInfoModalService.isSkipable;
  }

  async isUserProfileComplete(): Promise<boolean> {
    try {
      const currentSession = await this.authenticationService.GetCurrentSession();
      this.email = currentSession?.idToken?.payload?.email;
      const userPref = await firstValueFrom(this.surveyService.getProfileInCompleteSurvey())
      const isProfileCompleted = await this.checkUserProfileAttributes();
      if (userPref?.length > 0 || !isProfileCompleted) {
        return false;
      }
      else{
        this.callProfileCompletion = false;
        this.missingInfoModalService.forcedProfileCompletion = false;
      }
    } catch (error) {
      console.log(error);
    }

    return true;
  }
}
